module.exports = __webpack_public_path__ + "static/media/img4.dbb10f7f.png";